import {
  initReactI18next,
  useTranslation as useTranslationHook,
} from "react-i18next";
import i18next from "i18next";
import { getOptions } from "./options";
import resourcesToBackend from "i18next-resources-to-backend";

i18next

  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      return import(`./locales/${language}/${namespace}.json`);
    })
  )
  .init({
    ...getOptions(),
    partialBundledLanguages: true,
    lng: "en",
  });

export const useTranslation: typeof useTranslationHook = (ns, options) =>
  useTranslationHook(ns, options);
